import React from 'react';
import './Modal.css';

const CompanyProfileModal = ({ show, companyData, onClose }) => {
    if (!show || !companyData) return null;

    return (
        <div className="motor-modal-overlay" onClick={onClose}>
            <div
                className="motor-modal-content"
                style={{ maxWidth: '700px', width: '90%', padding: 0 }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="modal-header-dark">
                    <h4 className="m-0">
                        Company Profile
                    </h4>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body-content" style={{ padding: '20px', minHeight: '150px' }}>
                    {/* Header Info with Logo / Initials */}
                    <div className="d-flex align-items-center mb-4 p-3 bg-light rounded border">
                        <div className="me-3">
                            {companyData.company_logo ? (
                                <img
                                    src={companyData.company_logo}
                                    alt={companyData.company_name || ''}
                                    style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                                />
                            ) : (
                                <div className="company-initials-circle" style={{ backgroundColor: '#313131' }}>
                                    {companyData.company_initials || ''}
                                </div>
                            )}
                        </div>
                        <div>
                            <h3 className="fw-bold mb-1" style={{ color: '#313131' }}>{companyData.company_name}</h3>
                            <div className="d-flex gap-2 mt-2">
                                {companyData.initials && (
                                    <span className="badge bg-secondary">Sales Rep: {companyData.initials}</span>
                                )}
                                {companyData.payment_terms && (
                                    <span className="badge bg-dark text-white">Payment Terms: {companyData.payment_terms}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Address Section */}
                    <div className="card border mb-3">
                        <div className="card-header bg-light fw-bold" style={{ color: '#313131' }}>
                            Address
                        </div>
                        <div className="card-body">
                            <p className="mb-1 fw-semibold">{companyData.company_name}</p>
                            <p className="mb-1">{companyData.address || '-'}</p>
                            <p className="mb-0">
                                {[
                                    companyData.city,
                                    companyData.state_name,
                                    companyData.zip
                                ].filter(Boolean).join(', ') || '-'}
                            </p>
                        </div>
                    </div>

                    {/* Multipliers Section */}
                    {companyData.multipliers && companyData.multipliers.length > 0 && (
                        <div className="mt-4">
                            <h5 className="fw-bold mb-2" style={{ color: '#313131' }}>Account Multipliers</h5>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered text-center align-middle">
                                    <thead style={{ backgroundColor: '#313131', color: '#fff', borderBottom: '4px solid #bb5d40' }}>
                                        <tr>
                                            <th style={{ color: '#fff' }}>#</th>
                                            <th style={{ color: '#fff' }}>Multiplier Group</th>
                                            <th style={{ color: '#fff' }}>Customer Multiplier</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {companyData.multipliers.map((m, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td className="fw-semibold">{m.multiplier_group}</td>
                                                <td style={{ color: '#bb5d40', fontWeight: 600 }}>
                                                    {m.customer_multiplier}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                {/* Modal Footer */}
                <div className="modal-footer-dark">
                    <button type="button" className="btn btn-secondary px-4" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CompanyProfileModal;
